export const LeaveRequest = [
    {
        type: 'date',
        name: 'startDate',
        label: 'Start date',
        value: '',
        required: true,
        col: 'col-md-12'
    },
    {
        type: 'dropdown',
        name: 'stSession',
        label: 'Start session',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,
        options: [
            { value: 'fullday', name: 'Full day' },
            { value: 'firstsession', name: 'First session' },
            { value: 'secondsession', name: 'Second session' },
        ]
    },
    {
        type: 'date',
        name: 'enddate',
        label: 'End date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'dropdown',
        name: 'endSession',
        label: 'End session',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,
        options: [
            { value: 'fullday', name: 'Full day' },
            { value: 'firstsession', name: 'First session' },
            { value: 'secondsession', name: 'Second session' },
        ]
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px'
    }
];
export const SiftRequest = [
    {
        type: 'date',
        name: 'date',
        label: 'Date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'dropdown',
        name: 'currentShift',
        label: 'Current shift',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,
        options: [
            { value: 'shift-1', name: 'Shift-1' },
            { value: 'shift-2', name: 'Shift-2' },
            { value: 'shift-3', name: 'Shift-3' },
        ]
    },
    {
        type: 'dropdown',
        name: 'newShift',
        label: 'New Shift',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,
        options: [
            { value: 'shift-1', name: 'Shift-1' },
            { value: 'shift-2', name: 'Shift-2' },
            { value: 'shift-3', name: 'Shift-3' },
        ]
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px'
    }
];
export const TimeRequest = [
    {
        type: 'date',
        name: 'date',
        label: 'Date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'time',
        name: 'currentTime',
        label: 'Current time',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiline: true
    },
    {
        type: 'time',
        name: 'timeChange',
        label: 'Time change',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiline: true
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px'
    }
];
export const LocationRequest = [
    { 
        type: 'text',
        name: 'curLoc',
        label: 'Current location',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiline: true
    },
    {
        type: 'text',
        name: 'newLoc',
        label: 'New Location',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiline: true
    },
    {
        type: 'date',
        name: 'date',
        label: 'Date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px'
    }
];
export const RouteChangeRequest = [
    {
        type: 'date',
        name: 'date',
        label: 'Date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'dropdown',
        name: 'currentRoute',
        label: 'Current route',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,
        options: [
            { value: 'route-1', name: 'Route-1' },
            { value: 'route-2', name: 'Route-2' },
            { value: 'route-3', name: 'Route-3' },
        ]
    },
    {
        type: 'dropdown',
        name: 'newRoute',
        label: 'New route',
        value: '',
        required: true,
        col: 'col-md-12',
        options: [
            { value: 'route-1', name: 'Route-1' },
            { value: 'route-2', name: 'Route-2' },  
            { value: 'route-3', name: 'Route-3' },
        ]
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px',

    }
];
// export const RouteLocationChangeRequest = [
//     {
//         type: 'date',
//         name: 'date',
//         label: 'Date',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//     },
//     {
//         type: 'text',
//         name: 'location',
//         label: 'Location',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//         // multiline: true
//     },
//     {
//         type: 'checkbox',
//         name: 'transitMode',
//         label: 'Transit Mode',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//         options: [
//             { value: 'Login', name: 'Login' },
//             { value: 'Logout', name: 'Logout' },
//         ]
//     },
//     {
//         type: 'text',
//         name: 'message',
//         label: 'Message',
//         value: '',
//         required: false,
//         col: 'col-md-12',
//         multiline: true,
//         height: '60px',

//     }
// ];
export const OnBoardRequest = [
    {
        type: 'text',
        name: 'onBoard',
        label: 'On board',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiline: true
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px'
    }
];
export const AddressUpdateRequest = [
        {
            "type" : "map",
            "name" : "location",
            "label" : "Location",
            "value" : "",
            "required" : true,
            "col" : "col-md-12"
        },
        {
            "type" : "text",
            "name" : "address",
            "label" : "Address",
            "value" : "",
            "required" : true,
            "col" : "col-md-12"
        },
        {
            "type" : "text",
            "name" : "area",
            "label" : "Area",
            "value" : "",
            "required" : true,
            "col" : "col-md-12"
        },
        {
            "type" : "text",
            "name" : "city",
            "label" : "City",
            "value" : "",
            "required" : true,
            "col" : "col-md-12"
        },
        {
            "type" : "text",
            "name" : "pincode",
            "label" : "Pincode",
            "value" : "",
            "required" : true,
            "col" : "col-md-12"
        },
        {
            "type" : "date",
            "name" : "effectiveDate",
            "label" : "Effective Date",
            "value" : "",
            "required" : true,
            "col" : "col-md-12"
        },
        //  {
        //     "type" : "dropdown",
        //     "name" : "branch",
        //     "label" : "Branch",
        //     "value" : "",
        //     "required" : false,
        //     "col" : "col-md-12",
        //     "options" : [
        //         {
        //             "value" : "branch-1",
        //             "name" : "Branch-1"
        //         },
        //         {
        //             "value" : "branch-2",
        //             "name" : "Branch-2"
        //         },
        //         {
        //             "value" : "branch-3",
        //             "name" : "Branch-3"
        //         }
        //     ]
        // },
        {
            "type" : "dynamicDropdownZone",
            "name" : "zoneName",
            "label" : "Zone Name",
            "value" : "",
            "required" : false,
            "col" : "col-md-12",
            "options" : [
                {
                    "value" : "shift-1",
                    "name" : "Shift-1"
                },
                {
                    "value" : "shift-2",
                    "name" : "Shift-2"
                },
                {
                    "value" : "shift-3",
                    "name" : "Shift-3"
                }
            ]
        },
        {
            "type" : "dynamicNodalDropdown",
            "name" : "nodal",
            "label" : "Nodal Point",
            "value" : "",
            "required" : false,
            "col" : "col-md-12",
            "options" : [
                {
                    "value" : "shift-1",
                    "name" : "Shift-1"
                },
                {
                    "value" : "shift-2",
                    "name" : "Shift-2"
                },
                {
                    "value" : "shift-3",
                    "name" : "Shift-3"
                }
            ]
        },
        {
            "type" : "text",
            "name" : "message",
            "label" : "Message",
            "value" : "",
            "required" : false,
            "col" : "col-md-12",
            "multiline" : true,
            "height" : "60px"
        }
    ];
// export const AddressUpdateRequest = [
//     {
//         type: 'map',
//         name: 'location',
//         label: 'Location',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//     },
//     {
//         type: 'text',
//         name: 'address',
//         label: 'Address',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//     },
//     {
//         type: 'text',
//         name: 'area',
//         label: 'Area',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//     },
//     {
//         type: 'text',
//         name: 'city',
//         label: 'City',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//     },
//     {
//         type: 'text',
//         name: 'pincode',
//         label: 'Pincode',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//     },
//     {
//         type: 'date',
//         name: 'effectiveDate',
//         label: 'Effective Date',
//         value: '',
//         required: true,
//         col: 'col-md-12',
//     },
//     {
//         type: 'text',
//         name: 'message',
//         label: 'Message',
//         value: '',
//         required: false,
//         col: 'col-md-12',
//         multiline: true,
//         height: '60px'
//     },
//     // {
//     //     type: 'checkbox',
//     //     name: 'temporary',
//     //     label: '',
//     //     value: '',
//     //     required: false,
//     //     col: 'col-md-12',
//     //     options: [
//     //         { value: false, name: 'Temporary' },

//     //     ]
//     // },
//     // {
//     //   type: "date",
//     //   name: "locationChangeDate",
//     //   label: "Location Change Date",
//     //   value: "",
//     //   required: false,
//     //   col: "col-md-12"
//     // },
//     // {
//     //   type: "dropdown",
//     //   name: "transitMode",
//     //   label: "Transit Mode",
//     //   value: "",
//     //   required: false,
//     //   col: "col-md-12",
//     //   options: [
//     //     {
//     //       "value": "pickup",
//     //       "name": "Pickup"
//     //     },
//     //     {
//     //       "value": "drop",
//     //       "name": "Drop"
//     //     },
//     //     {
//     //       "value": "both",
//     //       "name": "Both"
//     //     }
//     //   ]
//     // }
// ];
export const RouteRequest = [
    {
        type: 'multipleDate',
        name: 'date',
        label: 'Trip Date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'checkbox',
        name: 'transitMode',
        label: 'Transit Mode',
        value: '',
        required: true,
        col: 'col-md-12',
        options: [
            { value: 'Login', name: 'Login' },
            { value: 'Logout', name: 'Logout' },
        ]
    },
    {
        type: 'dynamicDropdown',
        name: 'shift',
        label: 'Shift',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,

        options: [
            { value: 'shift-1', name: 'Shift-1' },
            { value: 'shift-2', name: 'Shift-2' },
            { value: 'shift-3', name: 'Shift-3' },
        ]
        // "options": [
        //     { value: "00:00", name: "00:00" },
        //     { value: "01:00", name: "01:00" },
        //     { value: "02:00", name: "02:00" },
        //     { value: "03:00", name: "03:00" },
        //     { value: "04:00", name: "04:00" },
        //     { value: "05:00", name: "05:00" },
        //     { value: "06:00", name: "06:00" },
        //     { value: "07:00", name: "07:00" },
        //     { value: "08:00", name: "08:00" },
        //     { value: "09:00", name: "09:00" },
        //     { value: "10:00", name: "10:00" },
        //     { value: "11:00", name: "11:00" },
        //     { value: "12:00", name: "12:00" },
        //     { value: "13:00", name: "13:00" },
        //     { value: "14:00", name: "14:00" },
        //     { value: "15:00", name: "15:00" },
        //     { value: "16:00", name: "16:00" },
        //     { value: "17:00", name: "17:00" },
        //     { value: "18:00", name: "18:00" },
        //     { value: "19:00", name: "19:00" },
        //     { value: "20:00", name: "20:00" },
        //     { value: "21:00", name: "21:00" },
        //     { value: "22:00", name: "22:00" },
        //     { value: "23:00", name: "23:00" }
        // ]
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px',

    }
];
export const AdhocRequest = [
    {
        type: 'multipleDate',
        name: 'date',
        label: 'Trip Date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'checkbox',
        name: 'transitMode',
        label: 'Transit Mode',
        value: '',
        required: true,
        col: 'col-md-12',
        options: [
            { value: 'Login', name: 'Login' },
            { value: 'Logout', name: 'Logout' },
        ]
    },
    {
        type: 'dynamicDropdown',
        name: 'shift',
        label: 'Shift',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,
        "options": [
            { value: "00:00", name: "00:00" },
            { value: "01:00", name: "01:00" },
            { value: "02:00", name: "02:00" },
            { value: "03:00", name: "03:00" },
            { value: "04:00", name: "04:00" },
            { value: "05:00", name: "05:00" },
            { value: "06:00", name: "06:00" },
            { value: "07:00", name: "07:00" },
            { value: "08:00", name: "08:00" },
            { value: "09:00", name: "09:00" },
            { value: "10:00", name: "10:00" },
            { value: "11:00", name: "11:00" },
            { value: "12:00", name: "12:00" },
            { value: "13:00", name: "13:00" },
            { value: "14:00", name: "14:00" },
            { value: "15:00", name: "15:00" },
            { value: "16:00", name: "16:00" },
            { value: "17:00", name: "17:00" },
            { value: "18:00", name: "18:00" },
            { value: "19:00", name: "19:00" },
            { value: "20:00", name: "20:00" },
            { value: "21:00", name: "21:00" },
            { value: "22:00", name: "22:00" },
            { value: "23:00", name: "23:00" }
        ]
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px',

    }
];
export const RouteCancelRequest = [
    {
        type: 'multipleDate',
        name: 'date',
        label: 'Trip Date',
        value: '',
        required: true,
        col: 'col-md-12',
    },
    {
        type: 'checkbox',
        name: 'transitMode',
        label: 'Transit Mode',
        value: '',
        required: true,
        col: 'col-md-12',
        options: [
            { value: 'Login', name: 'Login' },
            { value: 'Logout', name: 'Logout' },
        ]
        // options: [
        //     { value: 'Pickup', name: 'Pickup' },
        //     { value: 'Drop', name: 'Drop' },
        // ]
    },
    {
        type: 'dynamicDropdown',
        name: 'shift',
        label: 'Shift',
        value: '',
        required: true,
        col: 'col-md-12',
        // multiselect:true,
        options: [
            { value: 'shift-1', name: 'Shift-1' },
            { value: 'shift-2', name: 'Shift-2' },
            { value: 'shift-3', name: 'Shift-3' },
        ]
    },
    {
        type: 'text',
        name: 'message',
        label: 'Message',
        value: '',
        required: false,
        col: 'col-md-12',
        multiline: true,
        height: '60px',

    }
];
// table Cols

export const LeaveRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, headerConfig: { isDefault: true } },
    { key: 'startDate', display: 'Start date', config: { isDate: true, format: 'dd MMM YYYY' }, headerConfig: { isDefault: true } },
    { key: 'stSession', display: 'Start session', headerConfig: { isDefault: true } },
    { key: 'endDate', display: 'End date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'endSession', display: 'End session', headerConfig: { isDefault: true } },
    { key: 'message', display: 'Message' },
];

export const ShiftRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'currentShift', display: 'Current shift', headerConfig: { isDefault: true } },
    { key: 'changeShift', display: 'Change shift', headerConfig: { isDefault: true } },
    { key: 'message', display: 'Message' },
];

export const TimeRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'currentTime', display: 'Current time', headerConfig: { isDefault: true } },
    { key: 'timeChange', display: 'Change time', headerConfig: { isDefault: true } },
    { key: 'message', display: 'Message' },
];

export const LocationRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'currentLocation', display: 'Current location', headerConfig: { isDefault: true } },
    { key: 'latLong', display: 'Change location', headerConfig: { isDefault: true } },
    { key: 'message', display: 'Message' },
];

export const RouteChangeRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'currentRoute', display: 'Current route', headerConfig: { isDefault: true } },
    { key: 'changeRoute', display: 'Change route', headerConfig: { isDefault: true } },
    { key: 'message', display: 'Message' },
];

export const OnBoardRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'onBoard', display: 'On board', headerConfig: { isDefault: true } },
    { key: 'message', display: 'Message' },
];
export const AddressUpdateRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'address', display: 'Address' },
    { key: 'branch', display: 'Branch' },
    { key: 'nodal', display: 'Nodal Point' },
    { key: 'message', display: 'Message' },
];
export const RouteRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'type', display: 'Transit Mode' },
    { key: 'message', display: 'Message' },
];
export const RouteCancelRequestCols = [
    { key: 'name', display: 'Name' },
    { key: 'profile', display: 'Profile' },
    { key: 'createdAt', display: 'Submission date', headerConfig: { isDefault: true }, config: { isDate: true, format: 'dd MMM YYYY, hh:mm a' }, },
    { key: 'date', display: 'Date', config: { isDate: true, format: 'dd MMM YYYY' } },
    { key: 'type', display: 'Transit Mode' },
    { key: 'message', display: 'Message' },
];
// table data
export const LeaveRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, startDate: 1635935204000, stSession: 'First Session', endDate: 1636108004000, endSession: 'Second Session', message: 'Casual Leave' },
];

export const ShiftRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, currentShift: 'First Shift', changeShift: 'Second Shift', message: 'change shift' },
];

export const TimeRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, currentTime: '08:00 AM', timeChange: '03:00 PM', message: 'Changing Time' },
];

export const LocationRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, currentLocation: 'Velachery', latLong: 'Taramani', message: 'Changing Location' },
];

export const RouteChangeRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, currentRoute: 'Guindy', changeRoute: 'Medavakkam', message: 'Changing Route' },
    { name: 'prakash', profile: 'Driver', createdAt: 1635762300712, date: 1635935204000, currentRoute: 'Velachery', changeRoute: 'Tambaram', message: 'Route Change' },
];

export const OnBoardRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, onBoard: 'On Board', message: 'On Board Request' },
];

export const AddressUpdateRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, address: 'Keelkattalai,chennai.', message: 'Address Change Request' },
];

export const RouteRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, type: 'pickup', message: 'Route Request' },
];
export const RouteCancelRequestData = [
    { name: 'Raja', profile: 'Employee', createdAt: 1635762300712, date: 1635935204000, type: 'pickup', message: 'Route Request' },
];
// Design-only zone layout with nodal points.
// API-backed map/location fields are intentionally removed for now so the screen
// can be previewed safely until the real zone integration is ready.


export const RouteLocationChangeRequest = [
    {
      "bookingDays": 1
    },
    {
      "type": "multipleDate",
      "name": "date",
      "label": "Trip Date",
      "value": "",
      "required": true,
      "col": "col-md-12"
    },
    {
      "type": "map",
      "name": "location",
      "label": "Location",
      "value": "",
      "required": true,
      "col": "col-md-12"
    },
    {
      "type": "text",
      "name": "area",
      "label": "Area",
      "value": "",
      "required": true,
      "col": "col-md-12"
    },
    {
      "type": "checkbox",
      "name": "transitMode",
      "label": "Transit Mode",
      "value": "",
      "required": true,
      "col": "col-md-12",
      "options": [
        {
          "value": "Login",
          "name": "Login"
        },
        {
          "value": "Logout",
          "name": "Logout"
        }
      ]
    },
    {
      "type": "dynamicDropdownZone",
      "name": "zoneName",
      "label": "Zone Name",
      "value": "",
      "required": false,
      "col": "col-md-12",
      "options": [
        {
          "value": "shift-1",
          "name": "Shift-1"
        },
        {
          "value": "shift-2",
          "name": "Shift-2"
        },
        {
          "value": "shift-3",
          "name": "Shift-3"
        }
      ]
    },
    {
      "type": "dynamicNodalDropdown",
      "name": "nodal",
      "label": "Nodal Locations",
      "value": "",
      "required": false,
      "col": "col-md-12",
      "options": [
        {
          "value": "shift-1",
          "name": "Shift-1"
        },
        {
          "value": "shift-2",
          "name": "Shift-2"
        },
        {
          "value": "shift-3",
          "name": "Shift-3"
        }
      ]
    },
    {
      "type": "dynamicDropdown",
      "name": "shift",
      "label": "Shift",
      "value": "",
      "required": true,
      "col": "col-md-12",
      "options": [
        {
          "value": "shift-1",
          "name": "Shift-1"
        },
        {
          "value": "shift-2",
          "name": "Shift-2"
        },
        {
          "value": "shift-3",
          "name": "Shift-3"
        }
      ]
    },
    {
      "type": "text",
      "name": "message",
      "label": "Message",
      "value": "",
      "required": false,
      "col": "col-md-12",
      "multiline": true,
      "height": "60px"
    }
    ]
